/**
 * OpenSearch `multi_match` fields for media full-text search.
 * @see SEARCH-QUERY-REFERENCE.md §2
 */
export const MEDIA_TEXT_MULTI_FIELD_NAMES =
  "title,description,keywords,documentText,location,fileName,peopleTags,photoNumber"
